import axios from '../../../axios/index.js'
import store from '../../../../store/store.js'

// Token Refresh
let isAlreadyFetchingAccessToken = false
let subscribers = []

// let isRefreshing = false;
function onAccessTokenFetched (access_token) {
  
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber (callback) {
  subscribers.push(callback)
}
// function subscribeTokenRefresh(cb) {
//   subscribers.push(cb);
// }

// function onRefreshed() {
//   subscribers.map(cb => cb());
// }

export default {
//   init() {
// // let subscribers = [];

// axios.interceptors.response.use(
//   response => {
//     return response;
//   },
//   err => {
//     const {
//       config,
//       response: { status, data }
//     } = err;

//     const originalRequest = config;

//     if (data.message === "Missing token") {
//       this.$router.push({ name: "root" });
//       return Promise.reject(false);
//     }

//     if (originalRequest.url.includes("login")) {
//       return Promise.reject(err);
//     }

//     if (status === 401 && data.message === "Expired token") {
//       if (!isRefreshing) {
//         isRefreshing = true;
//         store
//           .dispatch("auth/fetchAccessToken")
//           .then(({ status }) => {
//             console.log('status')
//             console.log(status)
//             if (status === 200 || status == 204) {
//               isRefreshing = false;
//             }
//             subscribers = [];
//           })
//           .catch(error => {
//             console.error(error);
//           });
//       }

//       const requestSubscribers = new Promise(resolve => {
//         subscribeTokenRefresh(() => {
//           resolve(axios(originalRequest));
//         });
//       });

//       onRefreshed();

//       return requestSubscribers;
//     }
//   }
// );

//   },
  


  init () {

     // Request Interceptor
     axios.interceptors.request.use(
      config => {
        // Get token from localStorage
        const accessToken = localStorage.getItem('accessToken')

        // If token is present add it to request's Authorization Header
        if (accessToken) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `Bearer ${accessToken}`
        }
        return config
      },
      error => Promise.reject(error),
    )



    axios.interceptors.response.use(
      response => response, 
      error => {
      // const { config, response: { status } } = error
      const { config, response } = error
      const originalRequest = config
     
      //console.log('ERROR CONFIG')
      //console.log(config)
      //console.log(response.status)
      if (response && response.status === 401) {
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true
          store.dispatch('auth/fetchAccessToken')
            .then((res) => {
              isAlreadyFetchingAccessToken = false
              // console.log('PASOKKK')
              // console.log(res)
              // console.log(res.data.token)
              localStorage.setItem('accessToken', res.data.token)
              localStorage.setItem('refreshToken', res.data.refreshToken)
            
              onAccessTokenFetched(res.data.token)
            })
        }

        const retryOriginalRequest = new Promise((resolve) => {
          addSubscriber((res) => {
            // console.log('PASOKKK2')
            // console.log(res)
            originalRequest.headers.Authorization = `Bearer ${res}`
            resolve(axios(originalRequest))
          })
        })
        return retryOriginalRequest
      }
      return Promise.reject(error)
    })
  },
  tokenClear(){
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
  },
  login (email, pwd, timeZone) {
    return axios.post('/api/Account/SignIn', {
      username: email,
      password: pwd,
      timeZone: timeZone

    })
  },
  // registerUser (name, email, pwd) {
  //   return axios.post('/api/account/register', {
  //     email: email,
  //     password: pwd,
  //     employeeCode: "i046",	
  //     firstName: name,
  //     lastName: 'Hisanan',
  //     tenantsId: '3d490a70-94ce-4d15-9494-5248280c2ce3'
  //   })
  // },
  
  refreshToken () {
    try {
    return axios.post('/api/Account/SignIn/Refresh', null, { params : {
        token: localStorage.getItem('accessToken'),
        refreshToken:  localStorage.getItem('refreshToken'),
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone}
      })
    }
    catch (e) {
      const error = 'Invalid access token'
      return [401, {error}]
    }
  },
  forgotPassword(email) {
    return axios.post('/api/account/forgotpassword', null, { params : { email : email}})
  }
}
